<template>
  <div
    class="text-center"
    style="display: none"
  >
    <v-dialog
      v-model="dialog"
      width="500"
      attach=".map"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >{{ $i18n.t('dashboard.map.featureAttributes') }}</v-card-title>
        <v-card-text>
          <v-row v-if="fields.length === 0">
            <v-subheader style="height: auto; min-height: 48px;">
              <span>{{$i18n.t('dashboard.map.emptyFeatureAttributes')}}</span>
            </v-subheader>
          </v-row>
          <v-row
            no-gutters
            class="fields"
          >
            <v-col>
              <v-form>
                <template v-for="(field, idx) of fields">
                  <v-row
                    :key="idx"
                    class="pb-0"
                  >
                    <v-col>
                      <v-subheader style="height: auto; min-height: 48px;">
                        <span>{{field[$i18n.locale]}}</span>
                      </v-subheader>
                    </v-col>
                    <v-col cols="8">
                      <v-text-field
                        outlined
                        v-model="fieldsValues[field.pl]"
                      />
                    </v-col>
                  </v-row>
                </template>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="primary"
            text
            @click="cancel"
          >{{ $i18n.t('dialog.confirmation.cancel') }}</v-btn>
          <v-btn
            color="primary"
            text
            @click="success"
          >{{ $i18n.t('dialog.confirmation.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    fieldsValues: {}
  }),
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    fields: {
      required: true,
      type: Array
    }
  },
  methods: {
    success() {
      this.$emit('success', this.fieldsValues);
      for (let field of this.fields) {
        if (!this.fieldsValues.hasOwnProperty(field.pl)) {
          this.fieldsValues[field.pl] = '';
        }
      }
      this.fieldsValues = {};
    },
    cancel() {
      this.fieldsValues = {};
      this.$emit('cancel');
    }
  }
};
</script>